import classNames from 'classnames';
import React from 'react';
import { AlertBanner, AlertBannerTypes } from '../../Components/AlertBanner';
import styles from './LemiInfoBar.module.css';
export function LemiInfoBar() {
    var prompt = (React.createElement(React.Fragment, null,
        React.createElement("span", { className: styles.regular }, "This medication is on the "),
        React.createElement("span", { className: styles.veryStrongWords }, "List of Excluded Medicinal Items (LEMI)"),
        React.createElement("span", { className: styles.regular }, " and only the "),
        React.createElement("span", { className: classNames(styles.regular, styles.strongWords) }, "brand"),
        React.createElement("span", { className: styles.regular }, " will be printed on the prescription.")));
    return React.createElement(AlertBanner, { promptMessage: prompt, promptType: AlertBannerTypes.Prompt, verticalSpace: true });
}
